import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const PAGE_VERSION_ROUTES = {
  "campaign-list": { old: "/campaign-list", new: "/campaign-list-v2" },
  targeting: { old: "/optimizer/targeting", new: "/targeting-v2" },
  "bid-adjust": { old: "/bid-adjust", new: "/bid-adjust-v2" },
  "search-term": { old: "/search-term", new: "/search-term-v2" },
};

/**
 * Toggle between old and new optimizer page versions.
 * Place next to SectionTitle.
 *
 * @param {"campaign-list"|"targeting"|"bid-adjust"|"search-term"} pageKey
 * @param {boolean} isNewVersion - true when currently on the V2 page
 */
export default function PageVersionSwitchButton({ pageKey, isNewVersion = false }) {
  const navigate = useNavigate();
  const routes = PAGE_VERSION_ROUTES[pageKey];
  if (!routes) return null;

  const to = isNewVersion ? routes.old : routes.new;
  const label = isNewVersion ? "View Old Version" : "View New Version";

  return (
    <Button
      variant="text"
      color="primary"
      size="small"
      onClick={() => navigate(to)}
      sx={{
        ml: "auto",
        textTransform: "none",
        fontSize: "12px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        minWidth: "auto",
        px: 1,
      }}
    >
      {label}
    </Button>
  );
}
